// Horizontal poster filmstrip: scroll-snap carousel at every width (§4). On the
// printed-ticket sheet it reads as a strip of frames, never a wrapping wall.
// The poster tiles themselves are the design-system PosterCard (see brand.tsx).

export function PosterRow({ children, testid }: { children: React.ReactNode; testid?: string }) {
  return (
    <div data-testid={testid} className="mt-3 flex snap-x gap-3 overflow-x-auto pb-2 [scrollbar-width:thin]">
      {children}
    </div>
  );
}
